// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/common/verificationBanner/verificationBanner.scss
// module id = 639
// module chunks = 0